SNI.Application.addModule('recipe-body', (context) => {

  return {
    behaviors: ['read-more', 'region-toggle'],
    // init: () => context.broadcast('enable-region-toggle'),
  };
});
